(function($){
    $(document).ready(function(){
        $('[data-show-pma="1"] .elementor-screen-only').html('Ułatwienia dostępu');
        $('.elementor-nav-menu__container').attr('title', 'Menu główne');
        $('[data-id="1f7daf9"] ul').attr('title', 'Menu w stopce: Ważne linki');
        $('[data-id="8b08100"] ul').attr('title', 'Menu w stopce: Informacje');
        $('.elementskit-team-popup').each(function(){
            // $(this).attr('tabindex', 1);
            // $(this).attr('role', 'alert');
        })
        if($('.profile-card').length > 0){
            $('.profile-card').each(function(){
                $(this).attr('tabindex', 0);
                var title = $(this).next('.mfp-hide').find('.ekit-team-modal-content').html();
                if($(this).next('.mfp-hide').find('.ekit-team-modal-list').length > 0){
                    title = title + '<ul>'+$(this).next('.mfp-hide').find('.ekit-team-modal-list').html()+'</ul>';
                }
                $('<div class="elementor-screen-only" tabindex="0">'+title+'</div>').insertAfter($(this));
                // $(this).next('.mfp-hide').attr('title', title);
            });
            $('.profile-card .ekit-team-popup').each(function(){
                var linkElement = $(this);
                // Tworzymy nowy element div
                var divElement = $('<div>');

                // Kopiujemy wszystkie atrybuty z elementu <a> do elementu <div>
                $.each(linkElement[0].attributes, function(index, attribute) {
                    divElement.attr(attribute.name, attribute.value);
                });

                // Przenosimy zawartość (tekst lub inne elementy HTML) z <a> do <div>
                divElement.html(linkElement.html());

                // Zamieniamy <a> na <div>
                linkElement.replaceWith(divElement);
            });


        }
        if($('#form-field-email').length > 0){
            $('<label for="form-field-email">E-mail</label>').insertBefore('#form-field-email');
        }
        if ($('.forminator-checkbox__wrapper .forminator-consent').length > 0) {
            $('.forminator-checkbox__wrapper .forminator-consent').append('<span class="hlabel">' + $('.forminator-checkbox__wrapper .forminator-checkbox__label').html() + '</span>');
            $('.forminator-checkbox__wrapper .forminator-consent input').removeAttr('aria-labelledby');
        }
        if($('.ekit-team-modal-close').length > 0){
            $('.ekit-team-modal-close').each(function(){
                $(this).append('Zamknij');
            })
        }
        setTimeout(function(){
            if($('[name="quantityField"]').length > 0){
                $('[name="quantityField"]').attr('id', 'quantityField');
                $('<label class="hlabel" for="quantityField">Kwota</label>').insertBefore($('[name="quantityField"]'));
            }
            if($('.calc-range-slider').length > 0){
                var rl = '';
                $('.calc-range-slider').each(function(){
                    rl = (Math.random() + 1).toString(36).substring(7);
                    $(this).find('[type="range"]').attr('id', 'calc-field-' + rl);
                    $('<label class="hlabel" for="calc-field-'+rl+'">pole kalkulatora '+rl+'</label>').insertBefore($(this).find('[type="range"]'));
                })
                rl = (Math.random() + 1).toString(36).substring(7);
                $('<label class="hlabel" for="calc-field-'+rl+'">pole kalkulatora '+rl+'</label>').insertBefore('.input-number-counter');
            }
        }, 3000)
        $('.cky-notice-des, .skip-link[href="#content"]').remove();
        $('a').each(function(){
            if($(this).find('u').length > 0){
                var txt = $(this).find('u').text();
                $(this).html(txt);
                $(this).css('text-decoration', 'underline');
            }
        })

        $('.ekit-wid-con').each(function(){
            $('<p class="profile-title">'+$(this).find('.profile-title').html()+'</p>').insertAfter($(this).find('h2.profile-title'));
            $(this).find('h2.profile-title').remove();
        })
    })
})(jQuery)